import { render, staticRenderFns } from "./ClientRow.vue?vue&type=template&id=6e37f8be&scoped=true&"
import script from "./ClientRow.vue?vue&type=script&lang=js&"
export * from "./ClientRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e37f8be",
  null
  
)

export default component.exports